export default __webpack_public_path__ + "static/media/logo-isotim.f8936fa1.jpg";